"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOnOutsideClick", {
    enumerable: true,
    get: function() {
        return _useOnOutsideClick.useOnOutsideClick;
    }
});
const _useOnOutsideClick = require("./useOnOutsideClick");
